import React, { useEffect, useState } from 'react';
import { AccordionProps, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { useFormShowContext } from 'framework/form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';

interface DashboardItemSectionWrapperProps extends Omit<AccordionProps, 'title'> {
  defaultExpanded?: boolean;
  title: React.ReactNode;
  isExpandable?: boolean;
}

// For a list with you can use CollapsibleDataGridLayout
const DashboardItemSectionWrapper = ({
  title,
  children,
  defaultExpanded = false,
  isExpandable = true,
  ...props
}: DashboardItemSectionWrapperProps) => {
  const { isEditMode } = useFormShowContext();
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleChange = (event: any, isExpanded: boolean) => {
    const isExpandIconClick = event.target.closest('.MuiAccordionSummary-expandIconWrapper');

    if (isExpandIconClick) {
      setExpanded(isExpanded);
    }
  };

  const handleSummaryClick = (event: any) => {
    if (!event.target.closest('.MuiAccordionSummary-expandIconWrapper')) {
      event.stopPropagation();
    }
  };

  useEffect(() => {
    if (isEditMode) {
      setExpanded(true);
    }
  }, [isEditMode]);

  if (!isExpandable) {
    return (
      <Box data-testid="dashboard-item-section-accordion">
        <Box
          sx={{
            borderBottom: '1px solid',
            borderBottomColor: 'border.default',
            paddingLeft: '5px',
            padding: '8px 16px',
            minHeight: '40px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {title}
        </Box>
        <Box>{children}</Box>
      </Box>
    );
  }

  return (
    <Accordion expanded={expanded} onChange={handleChange} {...props} data-testid="dashboard-item-section-accordion">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fontSize: '20px' }} />}
        onClick={handleSummaryClick}
        sx={{
          borderBottom: '1px solid',
          borderBottomColor: 'border.default',
          flexDirection: 'row-reverse',
          minHeight: '40px !important',
          paddingLeft: '5px',
          '& .MuiAccordionSummary-content': {
            pointerEvents: 'auto',
            m: '0 0 0 10px !important',
          },
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default DashboardItemSectionWrapper;
